import { BaseFetch } from "../main-model"
export default class ReportThacherPowerRateModel extends BaseFetch {
    getReportThacherPowerRateBy = (data) =>
    this.authFetch({
      url: "report-thacher-power-rate/getReportThacherPowerRateBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
